export function initSnowfall({count     = 500, container = document.body} = {}) {
    for (let i = 0; i < count; i++) {
        const flake = document.createElement('div');
        flake.className   = 'snowflake';
        flake.textContent = '.';

        // random horizontal start 0–100vw
        flake.style.left = Math.random() * 100 + 'vw';

        // random size 8px–24px
        const size = Math.random() * 16 + 8;
        flake.style.fontSize = size + 'px';

        // random opacity 0.3–0.9
        flake.style.opacity = (Math.random() * 0.6 + 0.3).toFixed(2);

        // random fall duration 5–6s
        const fallDuration = Math.random() * 1 + 5;
        flake.style.setProperty('--fall-duration', fallDuration + 's');

        // diagonal drift: –50px to +50px
        const xOffset = Math.random() * 100 - 50 + 'px';
        flake.style.setProperty('--x-offset', xOffset);

        // random grey + alpha
        const grey = Math.floor(Math.random() * 255);
        const alpha = Math.random().toFixed(2);
        flake.style.setProperty('--flake-color',
            `rgba(${grey},${grey},${grey},${alpha})`
        );

        // staggered start
        flake.style.animationDelay = `-${Math.random() * fallDuration}s`;

        container.appendChild(flake);
    }
}
